/* eslint-disable no-unused-vars */
import { reactive } from "vue";
(function (window) {
	"use strict";
	function defineBreadcrumbsHelper() {
        
		var breadcrumbsStoreState = {
			debug: true,
			loadedFromSessionStorage: false,
			breadcrumbsPerPage: [],
			breadcrumbsSessionKey: "breadcrumbs",
			breadcrumbsPerPageSessionKey: "breadcrumbsPerPage",
			maxNumberOfBreadcrumbsToDisplay: 3,
			breadcrumbsState: reactive({
				breadcrumbs: [],
				lastBreadcrumbPopped: null
			}),
			storeBreadcrumbsInSessionStorage(){
				sessionStorage.setItem(this.breadcrumbsSessionKey, JSON.stringify(this.breadcrumbsState.breadcrumbs));
				sessionStorage.setItem(this.breadcrumbsPerPageSessionKey, JSON.stringify(this.breadcrumbsPerPage));
			},
			loadBreadcrumbs(){
				var breadcrumbsInSessionStorage = sessionStorage.getItem(this.breadcrumbsSessionKey);
				// if(breadcrumbsInSessionStorage !== null){
				//     //this.setBreadcrumbs(JSON.parse(breadcrumbsInSessionStorage));
				//     this.breadcrumbsState.breadcrumbs = JSON.parse(breadcrumbsInSessionStorage);
				//     this.loadedFromSessionStorage = true;
				// }
				var breadcrumbsForPagesInSessionStorage = sessionStorage.getItem(this.breadcrumbsPerPageSessionKey);
				if(breadcrumbsForPagesInSessionStorage !== null || breadcrumbsInSessionStorage !== null){
					this.breadcrumbsPerPage = JSON.parse(breadcrumbsForPagesInSessionStorage);
					//this.loadedFromSessionStorage = true;

					this.breadcrumbsState.breadcrumbs = JSON.parse(breadcrumbsInSessionStorage);
					this.loadedFromSessionStorage = true;
					this.storeBreadcrumbsInSessionStorage();
				}
                
			},
			setBreadcrumbs(breadcrumbs){
				this.breadcrumbsState.breadcrumbs = breadcrumbs;
				this.storeBreadcrumbsInSessionStorage();
				this.loadedFromSessionStorage = false;
			},
			setRootBreadcrumb(url, pageName){
				var breadcrumbs = [];
				var breadcrumb = {
					url: url,
					displayText: pageName
				};
				breadcrumbs.push(breadcrumb);
				this.setBreadcrumbs(breadcrumbs);
				this.loadedFromSessionStorage = false;
			},
			addNewBreadcrumbItem(breadcrumb){
				this.breadcrumbsState.breadcrumbs.push(breadcrumb);
			},
			getCurrentBreadcrumbs(){
				return this.breadcrumbsState.breadcrumbs;
			},
			getBreadcrumbsToDisplay(){
				return this.breadcrumbsState.breadcrumbs.slice(Math.max(this.breadcrumbsState.breadcrumbs.length - this.maxNumberOfBreadcrumbsToDisplay, 0));
			},
			updateBreadcrumbDisplayText(url, oldDisplayText, newDisplayText){
				var indexOfBreadcrumbToUpdate = this.breadcrumbsState.breadcrumbs.findIndex((breadcrumb => breadcrumb.displayText === oldDisplayText));
				if(indexOfBreadcrumbToUpdate > -1){
					this.breadcrumbsState.breadcrumbs[indexOfBreadcrumbToUpdate].displayText = newDisplayText;
					//this.setBreadcrumbsForPage(this.breadcrumbsState.breadcrumbs, oldDisplayText, url, newDisplayText);
				}
			},
			updateBreadcrumbs(route, pageName){
				if(!this.loadedFromSessionStorage){
					var breadcrumbForPage = this.getBreadcrumbForPage(pageName, route.path);
					if(breadcrumbForPage === undefined || breadcrumbForPage === null){
						//we have not navigated back to this page. add breadcrumb item
						var dailyReportFormBreadcrumb = {
							url: route.path,
							displayText: pageName
						};
						this.addNewBreadcrumbItem(dailyReportFormBreadcrumb);
						this.setBreadcrumbsForPage(this.getCurrentBreadcrumbs(), pageName, route.path);
					}
					else{
						var breadcrumbs = breadcrumbForPage.breadcrumbs;
						this.breadcrumbsState.breadcrumbs = [];
						//this.setBreadcrumbs(breadcrumbs);
						for(var i = 0; i < breadcrumbs.length; i++){
							var crumb = {
								displayText: breadcrumbs[i].displayText,
								url: breadcrumbs[i].url
							};
							this.breadcrumbsState.breadcrumbs.push(crumb);
						}
						this.storeBreadcrumbsInSessionStorage();
					}
				}
				else{
					this.loadedFromSessionStorage = false;
				}
                
			},
			setBreadcrumbsForPage(breadcrumbs, pageName, url, newPageName){
				//create a non-reactive copy of the current breadcrumbs to save for a page
				var b = JSON.parse(JSON.stringify(this.breadcrumbsState.breadcrumbs));
				var breadcrumbForPage = {
					pageName: pageName,
					url: url,
					breadcrumbs: b
				};
                
				var index = -1;
				for(var i = 0; i < this.breadcrumbsPerPage.length; i++){
					if(this.breadcrumbsPerPage[i].pageName ===  breadcrumbForPage.pageName && this.breadcrumbsPerPage[i].url ===  breadcrumbForPage.url){
						index = i;
						break;
					}
				}
				if(index < 0){
					this.breadcrumbsPerPage.push(breadcrumbForPage);
				}
				else{
					this.breadcrumbsPerPage[index] = breadcrumbForPage;
				}
				this.storeBreadcrumbsInSessionStorage();
			},
			getBreadcrumbForPage(pageName, url){
				return this.breadcrumbsPerPage.find(breadcrumb => breadcrumb.pageName === pageName && breadcrumb.url === url);
			}
		};
		return breadcrumbsStoreState;
	}
	//define globally if it doesn't already exist
	if (typeof (breadcrumbsStoreState) === "undefined") {
		window.breadcrumbsStoreState = defineBreadcrumbsHelper();
	} else {
		console.log("breadcrumbsStoreState already defined.");
	}
})(window);